var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import TctWindowEventContext from '../../context/tct-window-context';
import WindowConfigContext from '../../context/window-config-context';
import { ButtonItems } from './Communication';
import { TCT_CONFIG_CODE } from './Constants';
import { DialPadButton } from './PhoneCall';
var StyledLeftPane = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 48%;\n  padding: 20px;\n"], ["\n  width: 48%;\n  padding: 20px;\n"])));
var StyledRightPane = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 48%;\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  text-align: center;\n"], ["\n  width: 48%;\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  text-align: center;\n"])));
var dialPad = [
    { label: '1', id: 'dial_1' },
    { label: '2', id: 'dial_2' },
    { label: '3', id: 'dial_3' },
    { label: '4', id: 'dial_4' },
    { label: '5', id: 'dial_5' },
    { label: '6', id: 'dial_6' },
    { label: '7', id: 'dial_7' },
    { label: '8', id: 'dial_8' },
    { label: '9', id: 'dial_9' },
];
export function Configuration(props) {
    var goToMain = props.goToMain, activeButton = props.activeButton, setActive = props.setActive;
    var config = useContext(WindowConfigContext);
    var _a = useContext(TctWindowEventContext), _onConfigButtonClick = _a._onConfigButtonClick, _onSettingsButtonClick = _a._onSettingsButtonClick, _onSettingsActivateButtonClick = _a._onSettingsActivateButtonClick, _onButtonClick = _a._onButtonClick;
    var _b = useState(''), code = _b[0], setCode = _b[1];
    var onButtonClick = config.isBuilder
        ? _onButtonClick
        : _onSettingsButtonClick;
    var buttonClick = function (id) {
        setActive(TCT_CONFIG_CODE);
        onButtonClick(id);
    };
    var onPhonePadClick = function (item) {
        if (item.id === 'dial_back') {
            setCode(code.slice(0, -1));
        }
        else {
            setCode(code + item.label);
        }
        config.isBuilder ? _onButtonClick(item.id) : _onConfigButtonClick(item.id);
    };
    return (React.createElement(React.Fragment, null,
        activeButton === TCT_CONFIG_CODE ? (React.createElement(StyledLeftPane, null,
            React.createElement("div", null, "EMERGENCY LEVEL 1"),
            React.createElement("div", null, "To Activate Emergency level insert: 8835"),
            React.createElement("div", { style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    width: '100%',
                    height: '50%',
                } },
                dialPad.map(function (item) { return (React.createElement(DialPadButton, { key: item.id, id: item.id, width: '30%', onClick: function () { return onPhonePadClick(item); } }, item.label)); }),
                React.createElement("div", { style: { width: '30%' } }, code),
                React.createElement(DialPadButton, { id: 'dial_0', width: '30%', onClick: function () { return onPhonePadClick({ label: '0', id: 'dial_0' }); } }, "0"),
                React.createElement(DialPadButton, { id: 'dial_back', width: '30%', onClick: function () { return onPhonePadClick({ label: '<-', id: 'dial_back' }); } }, "<-")),
            React.createElement(DialPadButton, { width: '45%', id: 'tct_config_ok', onClick: function () {
                    return config.isBuilder
                        ? _onButtonClick('tct_config_ok')
                        : _onSettingsActivateButtonClick('tct_config_ok', code);
                } }, "Ok"),
            React.createElement(DialPadButton, { width: '45%', id: 'tct_config_cancel', onClick: function () { return _onButtonClick('tct_config_cancel'); } }, "Cancel"))) : (React.createElement(StyledLeftPane, null,
            React.createElement("div", null, "SICC-IP HERMESYS"),
            React.createElement("div", { style: { margin: 20 } },
                React.createElement("div", null, "Ship name: AVT"),
                React.createElement("div", null, "Version: AVT_VC1"),
                React.createElement("div", null, "Phone number: 1000"),
                React.createElement("div", null, "Mode: default")),
            React.createElement("div", { style: { margin: 20 } }, "Navantia Sistemas"))),
        React.createElement(StyledRightPane, null,
            React.createElement("div", { style: { width: '100%', height: '20%' } }),
            React.createElement("div", { style: { width: '45%' } }, "Test"),
            React.createElement("div", { style: { width: '45%' } }, "Mode"),
            React.createElement(ButtonItems, { onClick: function () { return onButtonClick('config_tct'); }, id: 'config_tct' }, "TCT"),
            React.createElement(ButtonItems, { onClick: function () { return buttonClick('config_default'); }, id: 'config_default' }, "DEFAULT"),
            React.createElement(ButtonItems, { onClick: function () { return onButtonClick('config_headphones'); }, id: 'config_headphones' }, "HEADPHONES"),
            React.createElement(ButtonItems, { onClick: function () { return onButtonClick('config_emergency'); }, id: 'config_emergency' }, "EMERGENCY"),
            React.createElement("div", { style: { width: '45%' } }, "SET UP"),
            React.createElement("div", { style: { width: '45%' } }),
            React.createElement(ButtonItems, { onClick: function () { return onButtonClick('config_setup'); }, id: 'config_setup' }, "50% 50%"),
            React.createElement(ButtonItems, { onClick: function () { return onButtonClick('config_brightness'); }, id: 'config_brightness' }, "50%"),
            React.createElement("div", { style: { width: '45%' } }),
            React.createElement(ButtonItems, { onClick: function () {
                    goToMain();
                    onButtonClick('config_exit');
                }, id: 'config_exit' }, "EXIT CONFIG"))));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=Configuration.js.map